import {
  VuexModule,
  Module,
  getModule,
  MutationAction,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { AuthService } from "@/services/auth.service";
import { UserPermissions } from "@/config/consts";
import { EmailService } from "@/services/api/email.service";
import { RestorePassw, UpdatePassword } from "~/update_password";

@Module({ dynamic: true, store, name: "auth" })
export class AuthVuexModule extends VuexModule {
  user: IUser | null = null;
  isLoggedIn: boolean = true;
  permissions: string[] = [];

  get isEmailMutationAvailable() {
    return this.permissions.includes(UserPermissions.ACCESS_ORGANIZATION);
  }

  get hasPermissionTo() {
    return (action: string) => {
      if (action) {
        return this.permissions.length
          ? this.permissions.includes(action)
          : false;
      } else {
        return true;
      }
    };
  }

  @Mutation
  public setIsLoggedIn(value: boolean) {
    this.isLoggedIn = value;
  }

  @Mutation
  public setUser(user: IUser) {
    this.user = user;
  }

  @MutationAction
  public async getUser() {
    const response = await AuthService.getUser();
    if (response.status != 200) return { user: null };

    return {
      user: response.data,
    };
  }

  @Action
  public async restorePassword(req: RestorePassw) {
    return await EmailService.restorePassword(req.email, req.recaptchaToken);
  }

  @Action
  public async isSercretHashExists(secretHash: string) {
    return await EmailService.isSercretHashExists(secretHash);
  }

  @Action
  public async updatePassword(req: UpdatePassword) {
    return await EmailService.updatePassword(req.secretHash, req.password);
  }

  @MutationAction
  public async getPermissions() {
    //const permissions = await AuthService.getPermissions();
    const permissions = [
      "accessOrganization",
      "signReconciliationAct",
      "rejectInvoiceAct",
      "rejectReconciliationAct",
      "signInvoiceAct",
      "accessAccept",
      "showReconciliationAct",
      "showInvoiceAct",
      "showInvoice",
      "feedback",
      "userManagement",
      "showSendCounts",
    ];

    return {
      permissions,
    };
  }
}

export const AuthModule = getModule(AuthVuexModule);
